<template>
    <section v-if="v$" titulo="Cadastro de Dados Pessoais" class="p-3">
        <!-- <Divider /> -->
        <div class="grid p-fluid mb-3">
            <p class="text-2xl mb-2 ml-3 text-primary">Meus dados</p>
        </div>

        <div class="formgrid grid p-fluid">
            <div class="field col-12 md:col-4">
                <label class="required" for="documento">CPF/CNPJ</label>
                <div class="p-inputgroup">
                    <InputText
                        id="documento"
                        :disabled="desabilitarDocumento"
                        :placeholder="docPlaceholder"
                        :value="documentoFormatado"
                        @input="formatarDocumento"
                        maxLength="18"
                        class="mr-3"
                        @blur="v$.documento.$touch()"
                    />
                    <Button class="p-button-default" icon="pi pi-search" label="Consultar no SAS" @click="consultarDocumento" />
                </div>
                <small class="p-error" v-if="v$.documento.required.$invalid && v$.documento.$error"> O CPF/CNPJ é obrigatório </small>
                <!-- <small class="p-error" v-if="v$.documento.docValido.$invalid && !v$.documento.required.$invalid"> Documento inválido </small> -->
            </div>
            <div class="field col-12 md:col-4">
                <label class="required" for="">Nome Completo</label>
                <InputText type="text" @blur="v$.nome.$touch()" v-model="nome" />
                <small class="p-error" v-if="v$.nome.$error">O nome é obrigatório</small>
            </div>
            <div class="field col-12 md:col-4">
                <label class="required" for="">E-mail</label>
                <InputText type="email" @input="v$.email.$touch()" v-model="email" />
                <small class="p-error" v-if="v$.email.$error">O e-mail é obrigatório</small>
            </div>
        </div>

        <div class="formgrid grid p-fluid" v-if="!documento || documento.length <= 12">
            <div class="field col-12 md:col-2">
                <label for="dataNasc">Data de Nasc.</label>
                <Calendar
                    v-model="dataNasc"
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :class="{ 'p-error': v$.dataNasc.$error }"
                    @date-select="v$.dataNasc.$touch()"
                    :manualInput="false"
                    showIcon
                    dateFormat="dd/mm/yy"
                    :maxDate="new Date()"
                />
                <small class="p-error" v-if="v$.dataNasc.$error">
                    <span v-if="v$.dataNasc.required.$invalid">A data de nascimento é obrigatória</span>
                    <span v-if="v$.dataNasc.dataValida.$invalid">Forneça uma data válida</span></small
                >
            </div>
        </div>
        <div class="formgrid grid p-fluid">
            <div class="field col-12 md:col-3">
                <label class="required" for="telefone">Telefone</label>
                <InputMask @blur="v$.telefone.$touch()" mask="(99) 99999-999?9" :unmask="true" v-model="telefone" />
                <small class="p-error" v-if="v$.telefone.$error">O telefone é obrigatório</small>
            </div>
        </div>

        <div class="grid p-fluid mt-1">
            <p class="text-sm text-500 ml-3">
                * Campo de preenchimento obrigatório <br />
                <!-- ** Pelo menos um dos campos deverá ser preenchido -->
            </p>
        </div>

        <Divider />
        <div class="grid p-fluid mt-3">
            <p class="text-2xl mb-2 ml-3 text-primary">Endereço</p>
        </div>

        <div class="formgrid grid p-fluid">
            <div class="field col-12 md:col-2">
                <label class="required" for="cep">CEP</label>
                <span class="btn-correios" @click="consultarCepExterno">
                    Correios
                    <span class="pi pi-external-link"></span>
                </span>
                <InputMask @blur="v$.cep.$touch()" v-model="cep" @complete="consultarCep" mask="99.999-999" :unmask="true" />
                <small class="p-error" v-if="v$.cep.$error">O CEP é obrigatório</small>
            </div>
            <div class="field col-12 md:col-4">
                <label class="required" for="logradouro">Logradouro</label>
                <InputText @blur="v$.logradouro.$touch()" v-model="logradouro" type="text" />
                <small class="p-error" v-if="v$.logradouro.$error">O logradouro é obrigatório</small>
            </div>
            <div class="field col-12 md:col-6">
                <label for="complemento">Número / Complemento</label>
                <InputText v-model="complemento" type="text" />
            </div>
        </div>

        <div class="formgrid grid p-fluid">
            <div class="field col-12 md:col-5">
                <label class="required" for="bairro">Bairro</label>
                <InputText @blur="v$.bairro.$touch()" v-model="bairro" type="text" />
                <small class="p-error" v-if="v$.bairro.$error">O bairro é obrigatório</small>
            </div>
            <div class="field col-12 md:col-4">
                <label class="required" for="cidade">Cidade</label>
                <InputText @blur="v$.cidade.$touch()" v-model="cidade" type="text" />
                <small class="p-error" v-if="v$.cidade.$error">A cidade é obrigatória</small>
            </div>
            <div class="field col-12 md:col-3">
                <label class="required">UF</label>
                <Dropdown @blur="v$.estado.$touch()" v-model="estado" :options="estados" optionLabel="text" optionValue="value" />
                <small class="p-error" v-if="v$.estado.$error">A UF é obrigatória</small>
            </div>
        </div>
        <div class="grid p-fluid mt-3 col-12 md:col-12 text-sm w-2">
            <Button v-if="v$" :disabled="v$.$invalid" label="Salvar" @click="salvarDados" />
        </div>
    </section>
    <router-view></router-view>
</template>

<script>
import Services from './services';
import useVuelidate from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import { estados } from '../../../../src/shared/components/estados';

export default {
    props: {
        cpfCnpjProp: {
            type: String,
            required: true,
        },
    },

    setup() {
        return { v$: useVuelidate({ $stopPropagation: true, $scope: 'ClienteForm' }) };
    },

    emits: ['clienteCadastrado'],

    data() {
        return {
            documento: null,
            nome: null,
            email: null,
            dataNasc: null,
            telefone: null,
            logradouro: null,
            complemento: null,
            estado: null,
            cidade: null,
            bairro: null,
            cep: null,
            cepConsultado: null,
            generos: [
                { nome: 'Feminino', cod: '1' },
                { nome: 'Masculino', cod: '2' },
                { nome: 'Prefiro não informar', cod: '0' },
            ],
            erros: [],
            estados: estados,
            error: null,
        };
    },

    computed: {
        docPlaceholder() {
            if (!this.documento || this.documento.length < 12) {
                return '000.000.000-00';
            }
            return '00.000.000/0000-00';
        },
        documentoFormatado() {
            if (!this.documento) return '';
            const digitsOnly = this.documento;

            if (digitsOnly.length <= 11) {
                return digitsOnly
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
            } else {
                return digitsOnly
                    .slice(0, 14)
                    .replace(/(\d{2})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1/$2')
                    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
            }
        },
    },

    validations() {
        return {
            documento: {
                required,
                documentoValido: () => {
                    const digitos = this.documento.replace(/\D/g, '');
                    return digitos.length === 11 ? this.$validarCPF(digitos) : digitos.length === 14 ? this.$validarCNPJ(digitos) : false;
                },
            },
            nome: { required },
            email: { required, email },
            dataNasc: {
                required: () => {
                    return this.documento && this.documento.length <= 12 ? required.$validator(this.dataNasc) : true;
                },
            },
            telefone: { required },
            logradouro: { required },
            estado: { required },
            cidade: { required },
            bairro: { required },
            cep: { required },
        };
    },

    mounted() {
        this.documento = this.cpfProp || null;
    },

    watch: {
        cpfCnpjProp: {
            handler(novoValor) {
                this.documento = novoValor || null;
            },
            immediate: true,
        },
    },

    methods: {
        formatarDocumento(event) {
            this.documento = event.target.value.replace(/\D/g, '');
        },

        consultarDocumento() {
            this.$store.dispatch('addRequest');
            this.consultarCpfCnpj().finally(() => this.$store.dispatch('removeRequest'));
        },

        async consultarCpfCnpj() {
            const documentoLimpo = (this.documento || '').replace(/\D/g, '');
            const isCpf = documentoLimpo.length === 11;
            const isCnpj = documentoLimpo.length === 14;

            if (!isCpf && !isCnpj) {
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Informe um CPF ou CNPJ válido', life: 3000 });
                return;
            }

            if (isCpf && !this.$validarCPF(documentoLimpo)) {
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'CPF inválido', life: 3000 });
                return;
            }

            if (isCnpj && !this.$validarCNPJ(documentoLimpo)) {
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'CNPJ inválido', life: 3000 });
                return;
            }

            this.$store.dispatch('addRequest');
            try {
                let response;
                if (isCnpj) {
                    response = await Services.consultarCnpj(documentoLimpo);
                } else {
                    response = await Services.consultarCpf(documentoLimpo);
                }
                if (!response?.data) {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Cadastro não encontrado', life: 3000 });
                    return;
                }
                this.preencherForm(response.data);
            } catch (error) {
                this.error = error;
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao consultar CPF/CNPJ', life: 3000 });
            } finally {
                this.$store.dispatch('removeRequest');
            }
        },

        async consultarCep() {
            const cepLimpo = (this.cep || '').replace(/\D/g, '');
            if (cepLimpo.length !== 8 || cepLimpo === this.cepConsultado) {
                return;
            }

            this.$store.dispatch('addRequest');
            try {
                const response = await Services.consultarCep(cepLimpo);

                if (response?.success === false) {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: response.errors?.join(' ') || 'Erro ao consultar CEP', life: 3000 });
                    return;
                }

                if (!response?.data) {
                    this.$toast.add({ severity: 'warn', summary: 'Atenção', detail: 'CEP não encontrado', life: 3000 });
                    return;
                }

                this.preencherEndereco(response.data);
                this.cepConsultado = cepLimpo;
            } catch (erro) {
                console.error('Falha ao consultar CEP', erro);
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao consultar CEP', life: 3000 });
            } finally {
                this.$store.dispatch('removeRequest');
            }
        },

        preencherEndereco({ street, neighborhood, city, state }) {
            this.logradouro = street || '';
            this.bairro = neighborhood || '';
            this.cidade = city || '';
            this.estado = state || this.estado;
        },

        consultarCepExterno() {
            window.open('https://buscacepinter.correios.com.br/app/endereco/index.php', '_blank');
        },

        salvarDados() {
            let clienteDto = {
                cpfCnpj: this.documento,
                nome: this.nome,
                email: this.email,
                dataNasc: this.dataNasc,
                telefone: this.telefone,
                logradouro: this.logradouro,
                complemento: this.complemento,
                estado: this.estado,
                cidade: this.cidade,
                bairro: this.bairro,
                cep: this.cep,
            };
            this.$store.dispatch('addRequest');
            Services.salvarDados(clienteDto).then((response) => {
                if (response.success) {
                    this.$store.dispatch('removeRequest');
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Dados salvos com sucesso', life: 3000 });
                    this.$emit('clienteCadastrado');
                    return;
                }
                this.$store.dispatch('removeRequest');
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao salvar dados', life: 3000 });
            });
        },
        preencherForm(cliente) {
            this.nome = cliente.nome;
            this.dataNasc = cliente.dataNasc ? new Date(cliente.dataNasc) : null;
            this.email = cliente.email;
            this.telefone = cliente.telefone;
            this.logradouro = cliente.logradouro;
            this.complemento = cliente.complemento;
            this.estado = cliente.estado;
            this.cidade = cliente.cidade;
            this.bairro = cliente.bairro;
            this.cep = cliente.cep;
        },
    },
};
</script>

<style scoped>
.btn-correios {
    background-color: #00416b;
    border-radius: 5px;
    color: #ffd400;
    cursor: pointer;
    margin-left: 10px;
    padding: 4px 8px 4px 4px;
}
</style>
